module.exports = __webpack_public_path__ + "media/images/emoticons/signaler-200a90e3eea3e78a975204f760cfc7cd.gif";